__turbopack_context__.v({
  "headingText": "styles-module__NdZ-yW__headingText",
});
